// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_UndoPeriodResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payroll/undo_period/{id}
 *
 * Returns a summary of what was deleted/unlinked when undoing a period.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_UndoPeriodResponseDados {
executions_deleted: number
deductions_deleted: number
recebimentos_unlinked: number
despesas_unlinked: number
}

export type Payroll_UndoPeriodResponse = ApiResponse<Payroll_UndoPeriodResponseDados>;

registerResponseContract('Payroll_UndoPeriodResponse', {
  executions_deleted:    { type: 'number',  required: true },
  deductions_deleted:    { type: 'number',  required: true },
  recebimentos_unlinked: { type: 'number',  required: true },
  despesas_unlinked:     { type: 'number',  required: true },
})
